import React from 'react';
import { get, isEmpty, set } from 'lodash';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { push } from 'react-router-redux';

import { createSandboxTask, isLoadingSandboxTask } from 'modules/engine-tasks';
import { showNotification } from 'modules/snackbar';
import { PropTypes } from 'helpers/react';
const {
  children,
  func,
  string,
  wizardConfigShape,
  arrayOf,
  shape,
  bool
} = PropTypes;

import popoverDialogWizardContainer from 'shared-components/Wizard/PopoverDialogWizardContainer';
import Wizard from 'shared-components/Wizard';
import wizardConfig from '../wizard-config';

@connect(
  (state, ownProps) => ({
    loadingSandboxTask: isLoadingSandboxTask(state)
  }),
  {
    push,
    showNotification,
    createSandboxTask
  }
)
export default class CreateTestWizardContainer extends React.Component {
  static propTypes = {
    wizardConfig: wizardConfigShape.isRequired,
    routes: arrayOf(
      shape({
        path: string
      })
    ).isRequired,
    onClose: func.isRequired,
    createSandboxTask: func.isRequired,
    showNotification: func.isRequired,
    push: func.isRequired,
    loadingSandboxTask: bool,
    params: shape({
      engineId: string.isRequired
    }).isRequired,
    children
  };
  static defaultProps = {
    wizardConfig
  };

  handleSubmit = values => {
    return this.props
      .createSandboxTask(this.props.params.engineId, values)
      .then(result => {
        // validation and server errors
        const errors = get(result, 'payload.errors');

        if (result.error || errors) {
          if (!errors || isEmpty(errors)) {
            return Promise.reject(
              new SubmissionError({
                _error:
                  "Failed to submit, but we can't tell why. Is your internet down?"
              })
            );
          }

          return Promise.reject(
            new SubmissionError({
              ...get(errors, '[0].data.validationErrors', []).reduce(
                (errorsMap, error) => ({
                  ...errorsMap,
                  ...set({}, error.fieldName, error.message)
                }),
                {}
              )
            })
          );
        }
        return result;
      })
      .then(this.handleSubmissionSuccess)
      .catch(this.handleSubmissionFailure);
  };

  handleSubmissionSuccess = ({ payload: { data, errors } }) => {
    if (!isEmpty(errors)) {
      return this.handleSubmissionFailure(errors);
    }

    this.props.showNotification('Task Created Successfully!');
    this.props.push(`/engines/${this.props.params.engineId}/tasks`);
  };

  handleSubmissionFailure = error => {
    if (get(error, 'errors._error')) {
      this.props.showNotification(
        'Creation failed. Something went wrong; please try again later.'
      );
    } else {
      this.props.showNotification(
        'Creation failed. Please go back and fix the marked errors before trying again.'
      );
    }

    throw error; // re-throw to let redux-form handle failure
  };

  render() {
    return (
      <Wizard
        formName="create-test-wizard"
        config={this.props.wizardConfig}
        currentPageNode={this.props.children}
        baseRoutePath={`/engines/${this.props.params.engineId}/tasks/new-task/`}
        onClose={this.props.onClose}
        isLoading={this.props.loadingSandboxTask}
        onSubmit={this.handleSubmit}
      >
        {popoverDialogWizardContainer({ title: 'New Task' })}
      </Wizard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/engines/pages/engine-tasks/pages/create-test-wizard/components/CreateTestWizardContainer.js